/**
 * bootFetch — use the request index.html already started (v149.64).
 *
 * `public/index.html` starts a bio / action page's data request as soon as
 * the HTML arrives (`window.__lkBoot = { url, res }`), so it loads alongside
 * the app's JavaScript instead of after it. The page asks for its URL here:
 * when it's the same URL, it gets that response (once — a later visit to
 * the page fetches fresh); otherwise this is an ordinary `fetch`.
 */
export function bootFetch(url, init) {
  try {
    const boot = typeof window !== "undefined" ? window.__lkBoot : null;
    if (boot && boot.url === url && !init) {
      window.__lkBoot = null;
      return boot.res;
    }
  } catch (_) { /* fall through */ }
  return fetch(url, init);
}
